var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSustainability(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3727_4200",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 41,
    height: 40
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.666504,
    width: 40,
    height: 40,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3727_4200)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.6666 33.1667C19.0408 33.1667 17.5094 32.8958 16.0724 32.3542C14.6352 31.8125 13.3333 31.0556 12.1666 30.0833L9.58325 32.625C9.33325 32.875 9.04853 33 8.72909 33C8.40964 33 8.12492 32.875 7.87492 32.625C7.62492 32.375 7.49992 32.0903 7.49992 31.7708C7.49992 31.4514 7.62492 31.1667 7.87492 30.9167L10.4166 28.3333C9.43492 27.1622 8.67561 25.8625 8.13867 24.4342C7.60172 23.0058 7.33325 21.4722 7.33325 19.8333C7.33325 16.1111 8.62492 12.9583 11.2083 10.375C13.7916 7.79167 16.9444 6.5 20.6666 6.5H33.9999V19.8333C33.9999 23.5556 32.7083 26.7083 30.1249 29.2917C27.5416 31.875 24.3888 33.1667 20.6666 33.1667ZM20.6666 30.6667C23.6758 30.6667 26.2337 29.6135 28.3403 27.5071C30.4467 25.4004 31.4999 22.8425 31.4999 19.8333V9H20.6666C17.6574 9 15.0995 10.0532 12.9928 12.1596C10.8864 14.2663 9.83325 16.8242 9.83325 19.8333C9.83325 21.1039 10.0416 22.3174 10.4583 23.4737C10.8749 24.6301 11.4444 25.6667 12.1666 26.5833L21.2083 17.5833C21.4583 17.3333 21.743 17.2083 22.0624 17.2083C22.3819 17.2083 22.6666 17.3333 22.9166 17.5833C23.1666 17.8278 23.2916 18.1181 23.2916 18.4542C23.2916 18.7903 23.1666 19.0833 22.9166 19.3333L13.9166 28.3333C14.8333 29.0556 15.8698 29.625 17.0262 30.0417C18.1826 30.4583 19.396 30.6667 20.6666 30.6667Z",
    fill: "#0AC032"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSustainability);
export default __webpack_public_path__ + "static/media/sustainability.0eaab75069d5aff8ee3dd7eb3725a699.svg";
export { ForwardRef as ReactComponent };